import React from "react";
import { ReactComponent as CallIcon } from "../../assets/svgs/CallIcon.svg";
import { ReactComponent as LinkedInLogo } from "../../assets/svgs/LinkedInLogo.svg";
import { ReactComponent as WhatsAppLogo } from "../../assets/svgs/WhatsAppLogo.svg";
import { motion } from "framer-motion";
import "./Socials.css";

const Socials = () => {
  const socialsContainer = {
    hidden: {
      opacity: 0,
      transition: { when: "beforeChildren" },
    },
    show: {
      opacity: 1,
      transition: {
        duration: 1,
        staggerChildren: 0.5,
        delayChildren: 2,
      },
    },
  };

  const socialIcon = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
    },
  };
  return (
    <motion.div
      variants={socialsContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      className="socials"
    >
      <motion.a
        variants={socialIcon}
        href="tel:+233555935570"
        target="_blank"
        rel="noopener noreferrer"
      >
        <CallIcon className="social-icon" />
      </motion.a>
      <motion.a
        variants={socialIcon}
        href="https://www.linkedin.com/in/michael-quarcoo/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkedInLogo className="social-icon" />
      </motion.a>
      <motion.a
        variants={socialIcon}
        href="https://wa.me/+233555935570"
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppLogo className="social-icon" />
      </motion.a>
    </motion.div>
  );
};

export default Socials;
